import React, { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

/**
 * Wrapper do reCAPTCHA v2 (Google).
 * O widget injeta iframe com ARIA próprio — axe pode reportar
 * aria-hidden-focus / aria-required-children / label dentro do iframe (3rd-party).
 * Mitigamos com group nomeado + hl pt-BR; não “consertar” o DOM do Google.
 */
function ReCaptcha({ handleOnCaptchaChange }, ref) {
  return (
    <div role="group" aria-label="Verificação de segurança reCAPTCHA">
      <ReCAPTCHA
        ref={ref}
        sitekey="6LeSHQETAAAAACjgu00LxcbscsmkkwMIqhfd1-Gh"
        onChange={handleOnCaptchaChange}
        hl="pt-BR"
      />
    </div>
  );
}

export default forwardRef(ReCaptcha);
